/**
 * Parse the next_step_advanced XML tag from message content
 */
export interface ExpertModePrompt {
  title: string;
  subtitle: string;
  context: string;
}

export function parseExpertModePrompt(content: string): ExpertModePrompt | null {
  // Match the XML tag with or without attributes and content
  const regex = /<next_step_advanced\s*[^>]*>([\s\S]*?)<\/next_step_advanced>/i;
  const match = content.match(regex);

  if (!match) {
    return null;
  }

  // Extract attributes - handle both regular quotes and special quotes
  // Match each quote type separately to handle apostrophes in content
  const titleMatch = content.match(/title\s*=\s*"([^"]*)"/) ||
                     content.match(/title\s*=\s*'([^']*)'/) ||
                     content.match(/title\s*=\s*"([^"]*)"/) ||
                     content.match(/title\s*=\s*"([^"]*)"/);

  const subtitleMatch = content.match(/subtitle\s*=\s*"([^"]*)"/) ||
                        content.match(/subtitle\s*=\s*'([^']*)'/) ||
                        content.match(/subtitle\s*=\s*"([^"]*)"/) ||
                        content.match(/subtitle\s*=\s*"([^"]*)"/);


  // Extract content inside the tag
  const context = match[1].trim();

  if (!context) {
    return null;
  }

  // Use default values if title or subtitle are missing
  const defaultTitle = "Besoin d'une analyse plus approfondie ?";
  const defaultSubtitle = "Passez en mode expert pour bénéficier de la méthodologie complète avec 7 questions de qualification et un plan d'action détaillé.";

  return {
    title: titleMatch ? titleMatch[1] : defaultTitle,
    subtitle: subtitleMatch ? subtitleMatch[1] : defaultSubtitle,
    context,
  };
}

/**
 * Remove the expert mode XML tag from content
 */
export function removeExpertModeTag(content: string): string {
  return content.replace(/<next_step_advanced\s*[^>]*>[\s\S]*?<\/next_step_advanced>/gi, '').trim();
}

/**
 * Check if content ends with expert mode prompt
 */
export function hasExpertModePrompt(content: string): boolean {
  return /<next_step_advanced\s*[^>]*>[\s\S]*?<\/next_step_advanced>/i.test(content);
}
